
import React, { createContext, useState, useContext } from "react";



const EnergiaIdentificacaoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaResponsavel_id, setEnergiaResponsavel_id] = useState();

  return (
    <EnergiaIdentificacaoContext.Provider value={{ energiaResponsavel_id, setEnergiaResponsavel_id }} >
      {children}
    </EnergiaIdentificacaoContext.Provider>
  );
}

export function useEnergiaIdentificacaoContext() {
  const context = useContext(EnergiaIdentificacaoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaResponsavel_id, setEnergiaResponsavel_id } = context;
  return { energiaResponsavel_id, setEnergiaResponsavel_id };
}

